import { useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import { CheckIcon } from "@heroicons/react/24/outline";
import { useServiceTypes } from "@/api/get-service-types";
import { useProfessions } from "@/api/get-professions";
import { SearchForm } from "@/features/patient/appointments/components/find/clinician-list-search-form";
import { ServiceBadge } from "@/features/home/components/service-badge";

function Home() {
    const methods = useForm();

    const navigate = useNavigate();
    const onSubmit = (data) => {
        navigate({
            pathname: "/clinicians/find",
            search: `?serviceType=${data.serviceSearch}`,
        });
    };

    const { data: serviceTypes } = useServiceTypes();
    const { data: professions } = useProfessions();

    return (
        <div className="flex h-full max-w-dvw flex-col">
            <div className="bg-logo h-full px-4 py-6">
                <div className="container mx-auto">
                    <div className="grid grid-cols-12 md:pt-24 md:pb-56">
                        <div className="col-span-full flex flex-col items-center text-center">
                            <h1 className="mb-6 text-5xl font-bold md:text-7xl">
                                Where clarity meets care.
                            </h1>
                            <p className="mb-6 max-w-2xl text-lg text-neutral-500">
                                Search, compare and book trusted clinicians,
                                from physiotherapists to specialists. <br />
                                Every professional properly vetted and within
                                easy reach.
                            </p>
                            <div className="mb-6 w-full md:max-w-[60ch] md:min-w-64">
                                <SearchForm
                                    methods={methods}
                                    onSubmit={onSubmit}
                                    serviceTypes={serviceTypes}
                                    professions={professions}
                                    hideCheck={true}
                                />
                            </div>
                            <p className="mb-3 text-sm text-neutral-500">
                                Some of our services on offer
                            </p>
                            <div className="mb-6 flex flex-wrap justify-center gap-2">
                                <ServiceBadge title="Physiotherapy" />
                                <ServiceBadge
                                    searchTerms="Mental health, Counselling"
                                    title="Mental health"
                                />
                                <ServiceBadge title="Doctor" />
                                <ServiceBadge title="Dentist" />
                                <ServiceBadge title="Pharmacist" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-auto flex bg-white px-4 py-6 ring ring-gray-200">
                <div className="container mx-auto flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
                    <div className="flex w-full items-center justify-center gap-2 text-center font-semibold md:w-auto">
                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-emerald-950 font-bold">
                            <CheckIcon className="size-4 shrink-0 stroke-2" />
                        </span>
                        <span className="text-darkgreen-400">
                            Every clinician verified against
                        </span>
                    </div>
                    <div className="flex gap-x-3 gap-y-1 font-[Montserrat] font-bold text-green-700">
                        <span>HCPC</span>
                        <span>&#8226;</span>
                        <span>NMC</span>
                        <span>&#8226;</span>
                        <span>GMC</span>
                        <span>&#8226;</span>
                        <span>GDC</span>
                        <span>&#8226;</span>
                        <span>DBS</span>
                    </div>
                    <span className="text-sm text-neutral-500">
                        Right to work & indemnity checked
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Home;
